import * as React from 'react';

import { Field } from 'redux-form';
import { useIntl } from 'react-intl';
import { useControls } from '../ReduxFormControls';
import {
    JRCInputFileAdavancedProps,
    JRCInputFileAdvancedRaw,
} from '../../JRCInputFileAdvanced/JRCInputFileAdvancedRaw';

export type JRCFormInputFileFieldProps = JRCInputFileAdavancedProps;

/**
 * @deprecated Use JRCInputFile instead
 */
export const JRCFormInputFileField = (props: JRCFormInputFileFieldProps) => {
    const intl = useIntl();
    const validate = useControls({ ...props, intl });
    return <Field component={JRCInputFileAdvancedRaw} validate={validate} {...props} />;
};
